/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";

import UserProfile from "./UserProfile";
import Logout from "./Logout";
import AppLogo from "../../../../assets/icons/MaxChatsLogo.svg";
import { Link } from "react-router-dom";
import { initializeSignalRConnection } from "../../../services/signalRService/signalRService";
import { useTwilio } from "../../../services/context/TwilioContext";
import { NetworkContext } from "../../../services/context/NetworkContext";
import { SignalWifiOff } from "@mui/icons-material";
function ChatNav() {
  const {
    setCallStatus,
    setActiveGroupRooms,
    setIsGroupCallRingtone,
    setReconnectingParticipants,
  } = useTwilio();

  const { internetAvailable } = useContext(NetworkContext);

  useEffect(() => {
    initializeSignalRConnection(
      setCallStatus,
      setActiveGroupRooms,
      setIsGroupCallRingtone,
      setReconnectingParticipants
    );
  }, []);
  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          position: "sticky", // Make it sticky
          top: 0, // Stick to the top of the viewport
          zIndex: 1000, // Ensure it stays on top of other elements
          padding: "10px",
          border: "0.5px solid #C6C5C5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#085F99",
          height: "65px",
        }}
      >
        {!internetAvailable && (
          <Box
            sx={{
              width: "100%",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F5F5F5",
              color: "red",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <SignalWifiOff sx={{ fontSize: 20, mr: 1 }} />
            <Typography sx={{ fontSize: "16px" }}>
              No Internet Connection!
            </Typography>
          </Box>
        )}
        {/* App Logo on the Left */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Link to={"/chats"}>
            <img
              src={AppLogo}
              alt="App Logo"
              style={{
                height: "100%",
                width: "65px",
              }}
            />
          </Link>
        </Box>

        {/* Profile and Logout on the Right */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2, // Spacing between profile and logout
          }}
        >
          <UserProfile />
          <Logout />
        </Box>
      </Grid>
    </>
  );
}

export default ChatNav;
